import { ApolloClient, InMemoryCache } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { createUploadLink } from 'apollo-upload-client';
import gql from 'graphql-tag';
import Config from "./config";
import { parseDateGQLField } from './utils';

const query = gql`
  query {
      isMenuOpen
  }
`;

const authLink = setContext((_, { headers }) => {
    const token = localStorage.getItem(Config.AUTH_TOKEN_KEY);
    const prefix = Config.JWT_AUTH_HEADER_PREFIX;
    return {
        headers: {
            ...headers,
            'authorization': token ? `${prefix} ${token}` : "",
        }
    };
});

const uploadLink = createUploadLink({
    uri: Config.GRAPHQL_API
});

export const client = new ApolloClient({
    cache: new InMemoryCache({
        typePolicies: {
            ContractConcessionOrganization: {
                fields: {
                    startDate: {
                        read(data) {
                            return parseDateGQLField(data)
                        }
                    },
                    endDate: {
                        read(data) {
                            return parseDateGQLField(data)
                        }
                    }
                }
            },
            ConcessionOrganizationAccreditation: {
                fields: {
                    startDate: {
                        read(data) {
                            return parseDateGQLField(data)
                        }
                    },
                    endDate: {
                        read(data) {
                            return parseDateGQLField(data)
                        }
                    }
                }
            },
            ConcessionOrganizationAccreditationDocument: {
                fields: {
                    expiresAt: {
                        read(data) {
                            return parseDateGQLField(data)
                        }
                    },
                    createdAt: {
                        read(data) {
                            return parseDateGQLField(data)
                        }
                    }
                }
            },
            ConcessionOrganizationDocument: {
                fields: {
                    expiresAt: {
                        read(data) {
                            return parseDateGQLField(data)
                        }
                    },
                    createdAt: {
                        read(data) {
                            return parseDateGQLField(data)
                        }
                    }
                }
            },
            Contract: {
                fields: {
                    startDate: {
                        read(data) {
                            return parseDateGQLField(data)
                        }
                    },
                    endDate: {
                        read(data) {
                            return parseDateGQLField(data)
                        }
                    },
                    realStartDate: {
                        read(data) {
                            return parseDateGQLField(data)
                        }
                    },
                    realEndDate: {
                        read(data) {
                            return parseDateGQLField(data)
                        }
                    },
                    createdAt: {
                        read(data) {
                            return parseDateGQLField(data)
                        }
                    }
                }
            },
            ContractDocument: {
                fields: {
                    expiresAt: {
                        read(data) {
                            return parseDateGQLField(data)
                        }
                    },
                    createdAt: {
                        read(data) {
                            return parseDateGQLField(data)
                        }
                    }
                }
            },
            ContractTransition: {
                fields: {
                    createdAt: {
                        read(data) {
                            return parseDateGQLField(data)
                        }
                    }
                }
            },
            WorkPermit: {
                fields: {
                    startAt: {
                        read(data) {
                            return parseDateGQLField(data)
                        }
                    },
                    endAt: {
                        read(data) {
                            return parseDateGQLField(data)
                        }
                    },
                    publishedAt: {
                        read(data) {
                            return parseDateGQLField(data)
                        }
                    }

                }
            },
            Task: {
                fields: {
                    startAt: {
                        read(data) {
                            return parseDateGQLField(data)
                        }
                    },
                    endAt: {
                        read(data) {
                            return parseDateGQLField(data)

                        }
                    }
                }
            },
            SurveyRecord: {
                fields: {
                    surveyedAt: {
                        read(data) {
                            return parseDateGQLField(data)
                        }
                    }
                }
            }
        }
    }),
    // @ts-ignore
    link: authLink.concat(uploadLink),
    resolvers: {
        Mutation: {
            loginUser: (_root, variables, { cache }) => {
                const { token } = variables;
                // cache.writeData({ data: { token } });
                localStorage.setItem(Config.AUTH_TOKEN_KEY, token);
                return true
            },
            logoutUser: (_root, _, { cache, }) => {
                localStorage.removeItem(Config.AUTH_TOKEN_KEY);
                cache.reset()
                return null;
            },
            setMenu: (_root, variables, { cache }) => {
                const state = variables.state;;
                cache.writeQuery({ query, data: { isMenuOpen: state } })
            }

        },
    }
});


client.writeQuery({ query, data: { isMenuOpen: false } })


export default client;
